import produce from 'immer';

// TYPES
import { Types, ExcluirFuncionalidade } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: ExcluirFuncionalidade = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ExcluirFuncionalidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_FUNCIONALIDADE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_FUNCIONALIDADE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_FUNCIONALIDADE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_FUNCIONALIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
